import { useState } from "react";
// @ts-ignore
import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import APIS from "../../../constant/Endpoint";
import usePostHook from "../../../customHooks/usePostHook";
import { QuickEmailForm } from "../../../utils/validationSchemas";
import Button from "../../Reusable/Button";
import Card from "../../Reusable/Card";
import EmailComboboxInput from "../../Reusable/EmailComboboxInput/EmailComboboxInput";
import MobilePreview from "../../Reusable/MobilePreview/MobilePreview";
import { RichTextEditor } from "../../Reusable/RichTextEditor";
import TextField from "../../Reusable/TextInput";
import AddEmailModal from "../AddEmailModal/AddEmailModal";
import EmailComboboxCreate from "../../Reusable/EmailComboboxCreate";

const AddQuickEmailCard = (props: any) => {
  const [isAddEmailModalOpen, setIsAddEmailModalOpen] = useState(false);
  const { refetch } = props;
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
    control,
    setValue,
    getValues,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(QuickEmailForm),
    defaultValues: async () => {
      const res = await refetch();
      return {
        sender: res?.data[0],
      };
    },
  });

  const message = watch("content");

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["emails"],
  });

  const handleCreate = async (values: any) => {
    const url = APIS.SEND_EMAIL;
    const formData = { ...values };
    try {
      const res = await mutateAsync({ url, formData, errors });
      if (res?.status === 200) {
        reset({
          sender: getValues("sender"),
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handlePlusButton = (e) => {
    e.preventDefault();
    setIsAddEmailModalOpen(true);
  };

  return (
    <div className={tw`pt-4`}>
      <div className={tw`min-h-[550px]`}>
        <Card>
          <div className={tw`flex flex-col lg:flex-row gap-4`}>
            <div className={tw`w-full lg:w-3/4`}>
              <form
                className={tw`flex flex-col gap-4`}
                onSubmit={handleSubmit(handleCreate)}
              >
                <EmailComboboxCreate
                  url={APIS.CONTACT}
                  queryKey="contact"
                  register={register("recipient")}
                  errors={errors.recipient}
                  name="recipient"
                  props={{ is_active: true }}
                  label={"To"}
                  setValue={setValue}
                  watch={watch}
                  getValues={getValues}
                  clearErrors={clearErrors}
                />

                <div className={tw`flex gap-4`}>
                  <div className={tw`w-[90%]`}>
                    <EmailComboboxInput
                      url={APIS.SENDER_EMAIL}
                      queryKey="email"
                      register={register("sender")}
                      errors={errors.sender}
                      name="sender"
                      props={{ is_active: true }}
                      label={"From"}
                      setValue={setValue}
                      watch={watch}
                      getValues={getValues}
                      clearErrors={clearErrors}
                    />
                  </div>
                  <div className={tw`w-[8%] relative top-6`}>
                    <div className={tw`text-[20px] leading-none text-center`}>
                      <Button
                        label="+"
                        type="button"
                        onClick={handlePlusButton}
                      />
                    </div>
                  </div>
                </div>
                <TextField
                  label="Subject"
                  placeholder="Write a subject here..."
                  register={register("subject")}
                  errors={errors.subject}
                />
                <RichTextEditor
                  register={register("content")}
                  setValue={setValue}
                  errors={errors.content}
                  label={<div>Message</div>}
                  registeredKey="content"
                  name="content"
                  control={control}
                />

                <div className={tw`flex justify-end`}>
                  <div className={tw`w-40`}>
                    <Button
                      label="Send Email"
                      type="submit"
                      isLoading={isPostLoading}
                    />
                  </div>
                </div>
              </form>
            </div>
            <div
              className={tw`hidden lg:flex items-center justify-center w-full lg:w-1/4`}
            >
              <div className="relative">
                <MobilePreview
                  imageUrl="https://dev-dib-pos-frontend-service-v3.s3.ap-south-1.amazonaws.com/digital-marketing-frontend-service/dist/30f7156109f80ad3a4d3.png"
                  description="Placeholders will be replaced for all contacts in a list. This is an example of the first contact."
                  message={message}
                />
              </div>
            </div>
          </div>
        </Card>

        <AddEmailModal
          isOpen={isAddEmailModalOpen}
          setIsOpen={setIsAddEmailModalOpen}
        />
      </div>
    </div>
  );
};

export default AddQuickEmailCard;
